// extracted by mini-css-extract-plugin
module.exports = {"box":"TenderTag__box___3Qc9W","box--border":"TenderTag__box--border___ckX5d"};